'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { COMPILED_HUBL_FETCH } from 'DesignData/actions/ActionTypes';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { UNINITIALIZED, SUCCEEDED, FAILED, PENDING } from 'DesignData/enums/RequestStatus';
/*

{
  byAsset: {
    [assetId]: {
      code: '<html>.....',
      revisions: {
        [revisionId]: '<html>.....',
        [revisionId]: '<html>.....',
      },
      compiledHubLFetchRequestStatus: RequestStatus...,
    },
  },
}

*/

const byAssedChildReducers = combineReducers({
  code(state = '', action) {
    switch (action.type) {
      case COMPILED_HUBL_FETCH:
        {
          const {
            code,
            revisionId
          } = action;
          return !revisionId && code != null ? code : state;
        }

      default:
        return state;
    }
  },

  revisions(state = EMPTY_OBJECT, action) {
    switch (action.type) {
      case COMPILED_HUBL_FETCH:
        {
          const {
            code,
            revisionId
          } = action;
          return revisionId && code != null ? SeamlessImmutable.set(state, revisionId, code) : state;
        }

      default:
        return state;
    }
  },

  compiledHubLFetchRequestStatus(state = UNINITIALIZED, action) {
    switch (action.type) {
      case COMPILED_HUBL_FETCH:
        {
          if (action.code) {
            return SUCCEEDED;
          } else if (action.error) {
            return FAILED;
          }

          return PENDING;
        }

      default:
        return state;
    }
  }

});
export default combineReducers({
  byAsset(state = EMPTY_OBJECT, action) {
    switch (action.type) {
      case COMPILED_HUBL_FETCH:
        {
          const {
            assetId
          } = action;
          if (!assetId) return state;
          return SeamlessImmutable.set(state, assetId, byAssedChildReducers(state[assetId], action));
        }

      default:
        return state;
    }
  }

});